import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// components
import SNSBtn from "../SNSBtn/SNSBtn";
//styles
import styles from "./SNSListStyle";
const useStyles = makeStyles(styles);

export default function SNSList(props) {
  const classes = useStyles();
  return (
    <div className={classes.SNSListContainer}>
      <div className={classes.snsHeader}>SNS</div>
      <div className={classes.icons}>
        {props.snsInfo.map((item, index) => {
          return (
            <SNSBtn
              color={item.color}
              icon={item.icon}
              url={item.url}
              key={index}
            />
          );
        })}
      </div>
    </div>
  );
}
